import { LoadingIndicator } from "@web-apps/ui-shared"
import { useEffect } from "react"

export const Redirect = ({ url }: { url: string }) => {
  useEffect(() => {
    window.location.href = url
  }, [url])
  return <LoadingIndicator size={100} isCentered />
}
